import { createContext, useContext } from 'react';

export interface DownloadUpsellContextValue {
  /** Call once per completed download — a batch counts as one. */
  notifyClipDownloaded: () => void;
}

export const DownloadUpsellContext =
  createContext<DownloadUpsellContextValue | null>(null);

const NOOP_VALUE: DownloadUpsellContextValue = {
  notifyClipDownloaded: () => {},
};

/**
 * Unlike the other app contexts this one never throws without a provider: it
 * is called from every clip download path, and a missing provider (a card
 * rendered outside `Layout`, a test harness) must degrade to silence rather
 * than break the download the user actually asked for.
 */
export function useDownloadUpsell(): DownloadUpsellContextValue {
  return useContext(DownloadUpsellContext) ?? NOOP_VALUE;
}
